export default __webpack_public_path__ + "static/media/exportIcon.9e942168.svg";